import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import config from "../../config";
import Swal from "sweetalert2";

const Privacy = () => {
  let userDetail = localStorage.getItem("ship_rocket_user");
  let userData = userDetail ? JSON.parse(userDetail) : {};

  const [sections, setSections] = useState({
    profile: false,
    reports: false,
    billing: false,
  });
  const [hasPassword, setHasPassword] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [passwordVerified, setPasswordVerified] = useState(false);
  const [passwordExpiry, setPasswordExpiry] = useState(null);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [currentSection, setCurrentSection] = useState("");
  const [passwordInput, setPasswordInput] = useState("");

  const [setupForm, setSetupForm] = useState({
    newPassword: "",
    confirmPassword: "",
    otp: "",
  });
  const [changeForm, setChangeForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    otp: "",
  });

  const [otpRequested, setOtpRequested] = useState(false);
  const [otpChangeRequested, setOtpChangeRequested] = useState(false);

  useEffect(() => {
    handlePrivacy();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (passwordExpiry && new Date() > new Date(passwordExpiry)) {
        setPasswordVerified(false);
        setPasswordExpiry(null);
      }
    }, 60000);
    return () => clearInterval(interval);
  }, [passwordExpiry]);

  const handlePrivacy = async () => {
    try {
      let url = config.apiUrl + "/user/privacy_settings";
      let dataToSend = { customer_id: userData.customer_id };
      const res = await axios.post(url, dataToSend, { headers: config.headers });
      if (res.data?.protected_sections) {
        setSections((prev) => ({
          ...prev,
          ...res.data.protected_sections.reduce((acc, val) => {
            acc[val] = true;
            return acc;
          }, {}),
        }));
        setHasPassword(!!res.data.has_password);
      }
    } catch (err) {
      console.error("Error fetching privacy settings", err);
    }
  };

  const handleToggle = (key) => {
    // Always update the toggle state
    setSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  
    // Then check if password modal needs to show
    if (hasPassword) {
      setCurrentSection(key);
      setShowPasswordModal(true);
    } else {
      setCurrentSection(key);
    }
  };

  const verifyPassword = async () => {
    try {
      const res = await axios.post(
        config.apiUrl + "/user/verify_and_toggle_section",
        {
          customer_id: userData.customer_id,
          password: passwordInput,
          section: currentSection
        },
        { headers: config.headers }
      );
  
      // Update local state with new sections
      setSections(prev => ({
        ...prev,
        [currentSection]: !prev[currentSection]
      }));
  
      // Set verification expiry
     
      setPasswordVerified(true);
      setPasswordExpiry(new Date(res.data.expires_at));
      setShowPasswordModal(false);
      setPasswordInput("");
      window.location.reload()
     
  
      Swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        background: "#198754",
        color: "white",
        icon: "success",
        title: res.data.message,
      });
  
    } catch (error) {
      Swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        background: "#a61c09",
        color: "white",
        icon: "error",
        title: error.response?.data?.message || "Operation failed",
      });
    }
  };

  const toggleSection = async (section) => {
    const newStatus = !sections[section];
    
    try {
      let url = config.apiUrl + (newStatus ? "/user/add_section_privacy" : "/user/remove_section_privacy");
      let dataToSend = { customer_id: userData.customer_id, section };
      await axios.post(url, dataToSend, { headers: config.headers });
      
      setSections(prev => ({ ...prev, [section]: newStatus }));
      
      Swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        background: "#198754",
        color: "white",
        icon: "success",
        title: `Section ${newStatus ? "protected" : "unprotected"} successfully`,
      });
    } catch (error) {
      console.error("Error toggling section", error);
      // Revert UI on error
      setSections(prev => ({ ...prev, [section]: !newStatus }));
    }
  };
  useEffect(() => {
    if (otpTimer > 0) {
      const timer = setTimeout(() => setOtpTimer(otpTimer - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [otpTimer]);

  const handleOtpRequest = async (change = false) => {
    try {
      let url = config.apiUrl + "/user/request_otp_privacy";
      let dataToSend = { customer_id: userData.customer_id };
      const res = await axios.post(url, dataToSend, { headers: config.headers });

      Swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        background: "#198754",
        color: "white",
        icon: "success",
        title: res.data.message || "OTP Sent Successfully",
      });

      setOtpTimer(60);
      if (change) setOtpChangeRequested(true);
      else setOtpRequested(true);
    } catch (err) {
      Swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        background: "#a61c09",
        color: "white",
        icon: "error",
        title: err.response?.data?.message || "Failed to send OTP",
      });
    }
  };

  const handleSetupSubmit = async (e) => {
    e.preventDefault();
    const { newPassword, confirmPassword, otp } = setupForm;
    if (!newPassword || newPassword !== confirmPassword || !otp) return;

    try {
      let url = config.apiUrl + "/user/set_password_privacy";
      let dataToSend = { customer_id: userData.customer_id, password: newPassword, otp , section: sections };
      const res = await axios.post(url, dataToSend, { headers: config.headers });

      Swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        background: "#198754",
        color: "white",
        icon: "success",
        title: res.data.message || "Password Set Successfully",
      });

      setOtpRequested(false);
      setSetupForm({ newPassword: "", confirmPassword: "", otp: "" });
      handlePrivacy();

      const modal = window.bootstrap.Modal.getInstance(document.getElementById("setupPasswordModal"));
      modal?.hide();
    } catch (error) {
      Swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        background: "#a61c09",
        color: "white",
        icon: "error",
        title: error.response?.data?.message || "Something went wrong",
      });
    }
  };

  const handleChangeSubmit = async (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, confirmPassword, otp } = changeForm;
    if (!currentPassword || !newPassword || newPassword !== confirmPassword || !otp) return;

    try {
      let url = config.apiUrl + "/user/change_password_privacy";
      let dataToSend = {
        customer_id: userData.customer_id,
        current_password: currentPassword,
        new_password: newPassword,
        otp,
      };
      const res = await axios.post(url, dataToSend, { headers: config.headers });

      Swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        background: "#198754",
        color: "white",
        icon: "success",
        title: res.data.message || "Password Updated",
      });

      setOtpChangeRequested(false);
      setChangeForm({ currentPassword: "", newPassword: "", confirmPassword: "", otp: "" });
      handlePrivacy();

      const modal = window.bootstrap.Modal.getInstance(document.getElementById("changePasswordModal"));
      modal?.hide();
    } catch (error) {
      Swal.fire({
        toast: true,
        position: "bottom-end",
        timer: 3000,
        showConfirmButton: false,
        background: "#a61c09",
        color: "white",
        icon: "error",
        title: error.response?.data?.message || "Something went wrong",
      });
    }
  };

  return (
    <div>
      <Header />
      <div className="page-wrapper pinned">
        <div className="main-container">
          <div className="app-container">
            <div className="app-body">
              <div className="container-fluid">
                <div className="d-flex justify-content-start mb-2">
                  <a href="javascript:window.history.back();">
                    <i className="bi bi-arrow-left me-2"></i>
                  </a>
                  <h2>Privacy Management</h2>
                </div>
                <div className="text-center w-100 ">
    <div className="text-danger fw-bold"><h2 style={{fontWeight:"bold"}}>Have Multiple Users?</h2></div>
    <div className="" style={{fontWeight:"bold" , color:"black"}}>Protect your confidential information with a password.</div>
  </div>
                <div className="card border-0 shadow-sm mt-2">
                  <div className="card-body p-4">
                    <h4 className="fw-bold">Choose the section to protect</h4>
                    {Object.entries(sections).map(([key, value]) => (
                      <div className="form-check form-switch mb-2" key={key}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={key}
                          checked={value}
                          onChange={() => handleToggle(key)}
                        />
                        <label className="form-check-label" htmlFor={key}>
                          {key === "profile" ? "Profile Settings" : key.charAt(0).toUpperCase() + key.slice(1)}
                        </label>
                      </div>
                    ))}

                    <div className="d-grid gap-3 mt-4">
                      {!hasPassword ? (
                        <button className="btn btn-primary py-2" data-bs-toggle="modal" data-bs-target="#setupPasswordModal">
                          <i className="bi bi-shield-lock me-2"></i>Save with Password
                        </button>
                      ) : (
                        <button className="btn btn-outline-secondary py-2" data-bs-toggle="modal" data-bs-target="#changePasswordModal">
                          <i className="bi bi-key me-2"></i>Change Password
                        </button>
                      )}
                    </div>

                   
                  </div>
                </div>

                {showPasswordModal && (
                  <div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title fw-bold">Enter Password</h5>
                          <button 
                            type="button" 
                            className="btn-close" 
                            onClick={() => setShowPasswordModal(false)}
                          />
                        </div>
                        <div className="modal-body">
                          <p>Please enter your password to modify {currentSection} settings</p>
                          <div className="mb-3">
                            <input
                              type="password"
                              className="form-control"
                              value={passwordInput}
                              onChange={(e) => setPasswordInput(e.target.value)}
                              placeholder="Enter your privacy password"
                            />
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setShowPasswordModal(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={verifyPassword}
                            disabled={!passwordInput}
                          >
                            Verify
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Setup Password Modal */}
                <div className="modal fade" id="setupPasswordModal" tabIndex="-1" aria-hidden="true">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <form onSubmit={handleSetupSubmit}>
                        <div className="modal-header">
                          <h5 className="modal-title fw-bold">Set Up Password Protection</h5>
                          <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                        <div className="alert alert-warning mt-2 mb-2">
                      <i className="bi bi-exclamation-triangle-fill me-2"></i>
                      <strong>Important:</strong> Please do not use your account password
                    </div>
                          <div className="mb-3">
                            <label className="form-label">New Password</label>
                            <input type="password" className="form-control" value={setupForm.newPassword} onChange={(e) => setSetupForm({ ...setupForm, newPassword: e.target.value })} />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Confirm Password</label>
                            <input type="password" className="form-control" value={setupForm.confirmPassword} onChange={(e) => setSetupForm({ ...setupForm, confirmPassword: e.target.value })} />
                          </div>
                          {otpRequested && (
                            <div className="mb-3">
                              <label className="form-label">Enter OTP</label>
                              <input type="text" maxLength={6} className="form-control text-center" value={setupForm.otp} onChange={(e) => setSetupForm({ ...setupForm, otp: e.target.value })} />
                            </div>
                          )}
                          <div className="d-grid gap-2 mt-3">
                            <button type="button" className="btn btn-primary" onClick={() => handleOtpRequest(false)} disabled={otpTimer > 0}>
                              {otpTimer > 0 ? `Resend OTP in ${otpTimer}s` : "Request OTP"}
                            </button>
                            <button
                              type="submit"
                              className="btn btn-success"
                              disabled={
                                !setupForm.newPassword ||
                                setupForm.newPassword !== setupForm.confirmPassword ||
                                !setupForm.otp
                              }
                            >
                              Save Password
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                {/* Change Password Modal */}
                <div className="modal fade" id="changePasswordModal" tabIndex="-1" aria-hidden="true">
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <form onSubmit={handleChangeSubmit}>
                        <div className="modal-header">
                          <h5 className="modal-title fw-bold">Change Password</h5>
                          <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                          <div className="mb-3">
                            <label className="form-label">Current Password</label>
                            <input type="password" className="form-control" value={changeForm.currentPassword} onChange={(e) => setChangeForm({ ...changeForm, currentPassword: e.target.value })} />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">New Password</label>
                            <input type="password" className="form-control" value={changeForm.newPassword} onChange={(e) => setChangeForm({ ...changeForm, newPassword: e.target.value })} />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Confirm Password</label>
                            <input type="password" className="form-control" value={changeForm.confirmPassword} onChange={(e) => setChangeForm({ ...changeForm, confirmPassword: e.target.value })} />
                          </div>
                          {otpChangeRequested && (
                            <div className="mb-3">
                              <label className="form-label">Enter OTP</label>
                              <input type="text" className="form-control text-center" maxLength={6} value={changeForm.otp} onChange={(e) => setChangeForm({ ...changeForm, otp: e.target.value })} />
                            </div>
                          )}
                          <div className="d-grid gap-2 mt-3">
                            <button type="button" className="btn btn-primary" onClick={() => handleOtpRequest(true)} disabled={otpTimer > 0}>
                              {otpTimer > 0 ? `Wait ${otpTimer}s` : "Request OTP"}
                            </button>
                            <button
                              type="submit"
                              className="btn btn-success"
                              disabled={
                                !changeForm.currentPassword ||
                                !changeForm.newPassword ||
                                changeForm.newPassword !== changeForm.confirmPassword ||
                                !changeForm.otp
                              }
                            >
                              Update Password
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Privacy;
